var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"divline"},[_vm._t("default"),_vm._m(0)],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"divline-edge"},[_c('div',{staticClass:"divline-etl"}),_c('div',{staticClass:"divline-etr"}),_c('div',{staticClass:"divline-ebl"}),_c('div',{staticClass:"divline-ebr"})])
}]

export { render, staticRenderFns }